export const SETUP_CONSOLE = 'SETUP_CONSOLE';
export const GET_LANGUAGE = 'GET_LANGUAGE';
export const GET_LANGUAGE_ERROR = 'GET_LANGUAGE_ERROR';
export const GET_LANGUAGE_SUCCESS = 'GET_LANGUAGE_SUCCESS';

export const setupConsole = locale => ({
  type: SETUP_CONSOLE,
  payload: locale,
});

export const getLanguage = locale => ({
  type: GET_LANGUAGE,
  payload: { locale },
});
